// extracted by mini-css-extract-plugin
export default {"cls1":"wpMIEACo4rVWhbgvZitS","cls2":"Nc4k7mbbDWAUygskw8Gz wpMIEACo4rVWhbgvZitS"};